import { UserInformationTextBox, UserOptionsBox } from '../molecules'

export const AppTopBar = () => {
  return (
    <div className="w-full flex items-center justify-between px-8 pt-4">
      <div className="flex items-center">
        <UserInformationTextBox />
      </div>
      <div className="flex items-center">
        <UserOptionsBox />
      </div>
    </div>
  )
}